
export const dataInfo = () => {
    return {
        "vicePresidentUnit": [
            {
                "id": "1546828825627459585",
                "createUser": -1,
                "createDept": -1,
                "createTime": "",
                "updateUser": -1,
                "updateTime": "",
                "status": -1,
                "isDeleted": -1,
                "dataType": -1,
                "institutionName": "腾讯技术有限公司",
                "leaguePosition": "",
                "trainingPrograms": "",
                "briefIntroduction": "眉山工程技师学院（中国水电七局高级技工学校）是经四川省人民政府批准设立，由眉山市人民政府与中国水电七局有限公司共建的一所具有企业办校优势和水电特色的综合性职业院校。学院是国家中等职业教育改革发展示范学校、国家级高技能人才培训基地、国家职业技能鉴定（川—042）所、四川省高技能人才培训基地、四川省省级劳务培训基地、四川省第二水电建设特有工种职业技能鉴定（电力095）站、四川省特种作业人员培训考核单位、水电七局职业技术培训中心和干部教育培训中心。",
                "trainingInstitutionName": "",
                "contact": "",
                "phone": "",
                "publishingUnit": "",
                "image": "",
                "publishTime": ""
            }
        ],
        "chairmanUnit": [
            {
                "id": "1546828474023149570",
                "createUser": -1,
                "createDept": -1,
                "createTime": "",
                "updateUser": -1,
                "updateTime": "",
                "status": -1,
                "isDeleted": -1,
                "dataType": -1,
                "institutionName": "华为技术有限公司",
                "leaguePosition": "",
                "trainingPrograms": "",
                "briefIntroduction": "这是一家非常棒的民族企业",
                "trainingInstitutionName": "",
                "contact": "",
                "phone": "",
                "publishingUnit": "",
                "image": "",
                "publishTime": ""
            }
        ],
        "alliance": {
            "id": -1,
            "createUser": -1,
            "createDept": -1,
            "createTime": "",
            "updateUser": -1,
            "updateTime": "",
            "status": -1,
            "isDeleted": -1,
            "dataType": -1,
            "institutionName": "退役军人教育培训联盟",
            "leaguePosition": "",
            "trainingPrograms": "",
            "briefIntroduction": "主要是为了推动和帮助退役军人完成第二次再就业，在四川省委省政府的领导下、眉山市委市政府的监管下特成立“眉山市退役军人教育培训联盟”",
            "trainingInstitutionName": "",
            "contact": "",
            "phone": "",
            "publishingUnit": "",
            "image": "",
            "publishTime": ""
        },
        "memberUnits": [
            {
                "id": "1546829012336902146",
                "createUser": -1,
                "createDept": -1,
                "createTime": "",
                "updateUser": -1,
                "updateTime": "",
                "status": -1,
                "isDeleted": -1,
                "dataType": -1,
                "institutionName": "字节跳动科技有限公司",
                "leaguePosition": "",
                "trainingPrograms": "",
                "briefIntroduction": "眉山工程技师学院（中国水电七局高级技工学校）是经四川省人民政府批准设立，由眉山市人民政府与中国水电七局有限公司共建的一所具有企业办校优势和水电特色的综合性职业院校。学院是国家中等职业教育改革发展示范学校、国家级高技能人才培训基地、国家职业技能鉴定（川—042）所、四川省高技能人才培训基地、四川省省级劳务培训基地、四川省第二水电建设特有工种职业技能鉴定（电力095）站、四川省特种作业人员培训考核单位、水电七局职业技术培训中心和干部教育培训中心。",
                "trainingInstitutionName": "",
                "contact": "",
                "phone": "",
                "publishingUnit": "",
                "image": "",
                "publishTime": ""
            }
        ]
    }
}


export const infoDetail = () => {
    return {
        "briefIntroduction": "眉山工程技师学院（中国水电七局高级技工学校）是经四川省人民政府批准设立，由眉山市人民政府与中国水电七局有限公司共建的一所具有企业办校优势和水电特色的综合性职业院校。学院是国家中等职业教育改革发展示范学校、国家级高技能人才培训基地、国家职业技能鉴定（川—042）所、四川省高技能人才培训基地、四川省省级劳务培训基地、四川省第二水电建设特有工种职业技能鉴定（电力095）站、四川省特种作业人员培训考核单位、水电七局职业技术培训中心和干部教育培训中心。",
        "contact": "",
        // "createDept": 0,
        // "createTime": "",
        // "createUser": 0,
        "dataType": 0,
        "id": 100,
        "image": "",
        "institutionName": "眉山工程技师学院",
        "isDeleted": 0,
        "leaguePosition": "会长单位",
        "phone": "",
        "trainingInstitutionName": "眉山工程技师学院",
        "trainingPrograms": "计算机操作员、制图员、美容、月嫂、养老护理员、家政服务员、营业员、创业培训、电子商务。",
    }
}